import { handleTrack } from '../../../../utils/tracker';

interface SIDEBAR_HEADING_PROPS {
  heading: string;
  isActive?: boolean;
  link?: string;
}

export const SidebarHeading = ({
  heading,
  isActive = false,
  link = '#',
}: SIDEBAR_HEADING_PROPS): JSX.Element => {
  return (
    <a
      href={link}
      onClick={(e) => {
        handleTrack({
          label: 'lhs_cta',
          obj: e.target,
        });
      }}
    >
      <div
        className={`text-base font-bold  py-2 cursor-pointer uppercase ${
          isActive ? 'text-blue-350' : 'text-font-500'
        }`}
      >
        {heading}
      </div>
    </a>
  );
};
